<template>
  <v-container class="px-0 my-3">
    <v-row>
      <v-col class="v-col-12 px-6 px-lg-0 v-col-lg-6 offset-lg-3">
        <div class="w-100 bg-white">
          <v-row>
            <v-col class="v-col-4 offset-4">
              <v-img src="@/assets/images/mobilesim.png" alt="Logo"></v-img>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-color-black text-center text-small">
              <b>VERSÃO {{ versionProject }}</b>
            </v-col>
          </v-row>
          <hr class="fine-line my-3">
          <v-row>
            <v-col cols="6" class="text-center cursor-pointer" @click="$router.push('/services/folhetos')">
              <div class="more-menu">
                <Svgs :icon="'folheto'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Folheto de ofertas</span>
            </v-col>
            <v-col cols="6" class="text-center cursor-pointer">
              <div class="more-menu">
                <Svgs :icon="'contato'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Entre em contato</span>
            </v-col>
          </v-row>
          <hr class="dashed-line my-3">
          <v-row class="ma-0">
            <v-col cols="3" class="text-center cursor-pointer" @click="$router.push('/profile/pedidos')">
              <div class="more-menu">
                <Svgs :icon="'carrinho'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Histórico de Pedidos</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer" @click="$router.push('/profile/enderecos')">
              <div class="more-menu">
                <Svgs :icon="'pin'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Lista de Endereços</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer" @click="$router.push('/institucional/comocomprar')">
              <div class="more-menu">
                <Svgs :icon="'money'" :color="'fill-color-1'" :width="33" :height="33"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Como Comprar</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer" @click="$router.push('/institucional/locaisehorarios')">
              <div class="more-menu">
                <Svgs :icon="'caminhao'" :color="'fill-color-1'" :width="35" :height="35"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Como é feita a entrega</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer pb-0" @click="$router.push('/institucional/politicadetroca')">
              <div class="more-menu">
                <Svgs :icon="'refazer'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Política de Troca</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer pb-0" @click="$router.push('/institucional/duvidasfrequentes')">
              <div class="more-menu">
                <Svgs :icon="'duvidas'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Dúvidas Frequentes</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer pb-0">
              <div class="more-menu">
                <Svgs :icon="'pin2'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Entrega ou Retirada</span>
            </v-col>
            <v-col cols="3" class="text-center cursor-pointer pb-0" @click="$router.push('/institucional/politicadeprivacidade')">
              <div class="more-menu">
                <Svgs :icon="'cadeado'" :color="'fill-color-1'" :width="30" :height="30"></Svgs>
              </div>
              <span class="text-color-0 text-xsmall">Polítia de Privacidade</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2"></v-col>
            <v-col cols="4" class="d-flex justify-center mb-3">
              <v-btn variant="outlined" block size="small" :color="'var(--color-black)'" @click="abrirLink('https://ofertas.mobilesim.com.br/p/'+group+'.html')">TERMOS DE USO</v-btn>
            </v-col>
            <v-col cols="4" class="d-flex justify-center mb-3">
              <v-btn variant="outlined" block size="small" :color="'var(--color-black)'" @click="abrirLink('https://mobilesim.com.br')">MOBILE SIM</v-btn>
            </v-col>
            <v-col cols="2"></v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import Svgs from '@/components/Svgs.vue';
export default {
  name: 'MoreInfo',
  components: {
    Svgs
  },
  data() {
    return {
      versionProject: import.meta.env.VITE_VERSION_PROJECT,
      group: import.meta.env.VITE_GROUP
    }
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig'
    }),
    abrirLink(link){
      window.open(link, '_blank');
    }
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
      } else {
        this.emitter.emit('dialogStores');
      }
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  }
}
</script>